module.exports = __webpack_public_path__ + "img/hqdzw.1adf1fe2.jpg";